import Vue from 'vue';
import VueRouter from 'vue-router';
import { Auth } from 'aws-amplify';
import { vxm } from '@/store';

const Login = () => import('@/components/login/LoginBase.vue');
const JoinSelect = () => import('@/components/register/JoinSelect.vue');
const CreateAccount = () => import('@/components/register/CreateAccount.vue');
const ConfirmSignUp = () => import('@/components/register/ConfirmSignUp.vue');
const ConfirmPassword = () => import('@/components/register/ConfirmPassword.vue');
const ConfirmPasswordSendCode = () => import('@/components/register/ConfirmPasswordSendCode.vue');
const ChangePassword = () => import('@/components/register/ChangePassword.vue');
const CreateOrganization = () =>
  import('@/components/register/CreateOrganization.vue');
const CreateProject = () => import('@/components/register/CreateProject.vue');
const ProjectJoin = () => import('@/components/register/ProjectJoin.vue');
const Home = () => import('@/components/home/HomeBase.vue');
const TaskDetail = () =>
  import('@/components/taskList/taskDetailModal/TaskDetailModalBase.vue');
const TaskList = () => import('@/components/taskList/TaskListBase.vue');
const Member = () => import('@/components/member/MemberBase.vue');
const JobList = () => import('@/components/jobList/Base.vue');
const RepositoryList = () => import('@/components/git/repositoryList/Base.vue');
const RepositoryDetail = () =>
  import('@/components/git/repositoryDetail/RepositoryDetailBase.vue');
const PullRequestDetail = () =>
  import('@/components/git/repositoryDetail/pullRequests/PullRequestDetail.vue');
const JobNew = () => import('@/components/jobNew/JobNewBase.vue');
const OrganizationDashboard = () =>
  import('@/components/organizationDashboard/OrganizationDashboardBase.vue');
const Documents = () => import('@/components/documents/DocumentsBase.vue');
const Documents2 = () => import('@/components/documents/DirectoryBase.vue');
const Documents3 = () => import('@/components/documents/DocumentEdit.vue');
const Profile = () => import('@/components/profile/ProfileBase.vue');
const ProfileEdit = () =>
  import('@/components/profile/profileEditList/ProfileEditBase.vue');
const StorageBase = () => import('@/components/storage/StorageBase.vue');
const StorageResult = () => import('@/components/storage/StorageResult.vue');
const HumanResourceSearch = () =>
  import('@/components/humanResourceSearch/HumanResourceSearchBase.vue');
const RecruitmentDashboard = () =>
  import('@/components/recruitment/dashboard/DashboardBase.vue');
const RecruitmentJobList = () =>
  import('@/components/recruitment/jobs/JobListBase.vue');
const RecruitmentCandidateList = () =>
  import('@/components/recruitment/candidates/CandidateListBase.vue');
const ProjectConfig = () =>
  import('@/components/config/ConfigBase.vue');
const ProjectConfigBasic = () => import('@/components/config/configList/BasicConfig.vue');
const ProjectConfigTheme = () => import('@/components/config/configList/Theme.vue');
const ProjectConfigTaskAttribute = () =>
  import('@/components/config/configList/TaskAttributeBase.vue');
const ProjectConfigGit = () => import('@/components/config/configList/Git.vue');
const ProjectConfigIntegration = () =>
  import('@/components/config/configList/Integration.vue');
const OrganizationConfig = () =>
  import('@/components/organizationConfig/OrganizationConfigBase.vue');
const OrganizationBasicConfig = () =>
  import(
    '@/components/organizationConfig/configList/OrganizationBasicConfig.vue'
  );
const OrganizationMember = () =>
  import('@/components/organizationConfig/configList/OrganizationMember.vue');
const ProjectList = () =>
  import('@/components/organizationConfig/configList/ProjectList.vue');
const StorageConfig = () =>
  import('@/components/organizationConfig/configList/StorageConfig.vue');
const UsagePlan = () =>
  import('@/components/organizationConfig/configList/UsagePlan.vue');
const ErrorPage = () => import('@/components/common/ErrorPage.vue');
const Shift = () => import('@/components/shift/ShiftBase.vue');
const MyDashboard = () => import('@/components/myDashboard/MyDashboardBase.vue');

Vue.use(VueRouter);

let routes: Array<any> = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'ログイン画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/joinSelect',
    name: 'joinSelect',
    component: JoinSelect,
    meta: {
      title: '参加選択画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/createAccount',
    name: 'createAccount',
    component: CreateAccount,
    meta: {
      title: 'アカウント登録画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/confirmSignUp',
    name: 'confirmSignUp',
    component: ConfirmSignUp,
    meta: {
      title: 'アカウント登録確認コード入力画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/sendConfirmCode',
    name: 'sendConfirmCode',
    component: ConfirmPasswordSendCode,
    meta: {
      title: '確認コード送信画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/confirmPassword',
    name: 'confirmPassword',
    component: ConfirmPassword,
    meta: {
      title: 'パスワード忘れ画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: ChangePassword,
    meta: {
      title: 'パスワード変更画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/createOrganization',
    name: 'createOrganization',
    component: CreateOrganization,
    meta: {
      title: '組織追加画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/createProject',
    name: 'createProject',
    component: CreateProject,
    meta: {
      title: 'プロジェクト作成画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/projectJoin',
    name: 'projectJoin',
    component: ProjectJoin,
    meta: {
      title: 'プロジェクト参加画面',
      isPublic: false,
      keepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'ホーム',
      isPublic: false,
      KeepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/tasks',
    name: 'taskList',
    component: TaskList,
    meta: {
      title: 'タスク一覧',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/tasks/:id',
    name: 'task',
    component: TaskDetail,
    meta: {
      title: 'タスクタイトル',
      KeepAlive: false,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/member',
    name: 'member',
    component: Member,
    meta: {
      title: 'メンバー',
      KeepAlive: false,
      isAuthority: '',
    },
  },
  {
    path: '/jobs',
    name: 'jobList',
    component: JobList,
    meta: {
      title: 'お仕事一覧',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/jobs/new',
    name: 'jobNew',
    component: JobNew,
    meta: {
      title: '案件新規作成',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/git',
    name: 'git',
    component: RepositoryList,
    meta: {
      title: 'Gitリポジトリ一覧',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/git/:id',
    name: 'repository',
    component: RepositoryDetail,
    meta: {
      title: 'Gitリポジトリ詳細',
      isPublic: false,
      KeepAlive: false,
      isAuthority: '',
    },
  },
  {
    path: '/git/:id/pullrequest',
    name: 'pullrequest',
    component: PullRequestDetail,
    meta: {
      title: 'プルリクエスト詳細',
      isPublic: false,
      KeepAlive: false,
      isAuthority: '',
    },
  },
  {
    path: '/organization',
    name: 'organizationDashboard',
    component: OrganizationDashboard,
    meta: {
      title: '組織ダッシュボード',
      isPublic: false,
      KeepAlive: false,
      isAuthority: '',
    },
  },
  {
    path: '/documents',
    name: 'documents',
    component: Documents,
    meta: {
      title: 'documents',
      isPublic: false,
      KeepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/documents2',
    name: 'documents2',
    component: Documents2,
    meta: {
      title: 'documents2',
      isPublic: false,
      KeepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/documents3',
    name: 'documents3',
    component: Documents3,
    meta: {
      title: 'documents3',
      isPublic: false,
      KeepAlive: true,
      isAuthority: '',
    },
  },
  {
    path: '/profile/:id',
    name: 'profile',
    component: Profile,
    meta: {
      title: 'プロフィール',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    // TODO: pathを修正(宮崎)
    path: '/profile/:id/edit',
    name: 'profileEdit',
    component: ProfileEdit,
    meta: {
      title: 'プロフィール編集',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/human-resource-search',
    name: 'humanResourceSearch',
    component: HumanResourceSearch,
    meta: {
      title: '人材検索',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/myDashboard',
    name: 'myDashboard',
    component: MyDashboard,
    meta: {
      title: 'マイダッシュボード',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/storage',
    name: 'storage',
    component: StorageBase,
    meta: {
      title: 'ディレクトリホーム',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/recruitment/dashboard',
    name: 'recruitmentDashboard',
    component: RecruitmentDashboard,
    meta: {
      title: '求人案件管理ホーム',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/recruitment/jobs',
    name: 'recruitmentJobList',
    component: RecruitmentJobList,
    meta: {
      title: '求人案件一覧',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/recruitment/candidates',
    name: 'recruitmentCandidateList',
    component: RecruitmentCandidateList,
    meta: {
      title: '候補者一覧',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
  {
    path: '/config',
    name: 'config',
    component: ProjectConfig,
    meta: {
      title: 'プロジェクト設定',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
    children: [
      {
        path: 'basic',
        name: 'projectConfigBasic',
        component: ProjectConfigBasic,
      },
      {
        path: 'theme',
        name: 'projectConfigTheme',
        component: ProjectConfigTheme,
      },
      {
        path: 'taskAttribute',
        name: 'projectConfigTaskAttribute',
        component: ProjectConfigTaskAttribute,
      },
      {
        path: 'git',
        name: 'projectConfigGit',
        component: ProjectConfigGit,
      },
      {
        path: 'integration',
        name: 'projectConfigIntegration',
        component: ProjectConfigIntegration,
      },
    ],
  },
  {
    path: '/organizationConfig',
    name: 'organizationConfig',
    component: OrganizationConfig,
    meta: {
      title: '組織設定',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
    children: [
      {
        path: 'basic',
        name: 'organizationBasic',
        component: OrganizationBasicConfig,
      },
      {
        path: 'projects',
        name: 'organizationProjects',
        component: ProjectList,
      },
      {
        path: 'member',
        name: 'organizationMember',
        component: OrganizationMember,
      },
      {
        path: 'changePlan',
        name: 'changePlan',
        component: UsagePlan,
      },
      {
        path: 'storageConfig',
        name: 'storageConfig',
        component: StorageConfig,
      },
    ],
  },
  {
    path: '/errorPage',
    name: 'errorPage',
    component: ErrorPage,
    meta: {
      title: 'エラー',
      KeepAlive: true,
      isPublic: true,
      isAuthority: '',
    },
  },
  {
    path: '/shift',
    name: 'shift',
    component: Shift,
    meta: {
      title: 'ディレクトリ一覧',
      KeepAlive: true,
      isPublic: false,
      isAuthority: '',
    },
  },
];

// 単体テスト
import UnitTest from '@/components/unittest/UnitTestBase.vue';
import TestEditableText from '@/components/unittest/TestEditableText.vue';
import { SignInResponse } from './@types/Auth';
const unittestroutes: Array<any> = [
  {
    path: '/unittest/',
    name: 'unittest',
    component: UnitTest,
  },
  // EditableText:編集可能な固定文字列
  {
    path: '/unittest/editabletext',
    name: 'editabletext',
    component: TestEditableText,
  },
];
routes = routes.concat(unittestroutes);

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  /**未ログインユーザーがアクセス不可のページへのアクセス、組織・プロジェクト新規作成関連ページ以外へのアクセスの場合 */
  if (
    to.name !== 'login' &&
    to.name !== 'createAccount' &&
    to.name !== 'confirmSignUp' &&
    to.name !== 'confirmPassword' &&
    to.name !== 'joinSelect' &&
    to.name !== 'createOrganization' &&
    to.name !== 'createProject' &&
    to.name !== 'projectJoin' &&
    to.name !== 'sendConfirmCode'
  ) {
    /**セッション情報を取得 */
    const currentUserInfo = await Auth.currentUserInfo();
    /** セッションが無効の場合ストアのstateを削除する */
    if (!currentUserInfo) {
      vxm.theoryApi.authStore.deleteCurrentUserInfo();
      next({ name: 'login' });
    } else {
      /**セッションが生きておりstateがnullの場合 */
      if (!vxm.theoryApi.authStore.getCurrentUserInfo) {
        /**stateにアカウント情報をset */
        await vxm.theoryApi.authStore.fetchCurrentUserInfo();
        const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo as SignInResponse | null;
        /** 正常に取得出来なかった場合はログインページへリダイレクトする */
        if (!userInfo) {
          next({ name: 'login' });
        } else {
          /**所属組織が存在しない場合、カレント組織IDを削除し作成ページへ遷移させる */
          if (!userInfo.results.organizationId) {
            vxm.theoryApi.authStore.fetchCurrentProjectIds(null);
            next({ name: 'joinSelect' });
          } else {
          /**組織IDをsetし、組織のプロジェクトのうちアカウントが現在参画しているものの一覧をstateにset */
            vxm.theoryApi.authStore.fetchCurrentOrganizationId(userInfo.results.organizationId);
            await vxm.theoryApi.accountsStore.fetchAccountBasicParticipationProjects({
              accountId: userInfo.results.accountId,
              organizationId: userInfo.results.organizationId,
            });
            /**プロジェクトIDsをセット */
            if (vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects) {
              const projectIds = vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects.results.map((project) => {
                return project.projectId;
              });
              vxm.theoryApi.authStore.fetchCurrentProjectIds(projectIds);
              /**プロジェクト一覧が無い場合stateを削除 */
            } else {
              vxm.theoryApi.authStore.fetchCurrentProjectIds(null);
            }
            /**プロジェクトIDをセット */
            if (userInfo.results.projectId) {
              vxm.theoryApi.authStore.fetchCurrentProjectId(userInfo.results.projectId);
              /**プロジェクトIDがnullの場合カレントプロジェクトIDを削除 */
            } else {
              vxm.theoryApi.authStore.fetchCurrentProjectId(null);
            }
            /**マスタデータがストアに無い場合取得する */
            if (!vxm.theoryApi.mastersStore.getExistFlag) {
              await vxm.theoryApi.mastersStore.fetchMasterData();
            }
            next();
          }
        }
        /**セッションが生きておりstateがnullでない場合 */
      } else {
        /**カレント組織が存在しない場合 */
        if (!vxm.theoryApi.authStore.getCurrentOrganizationId) {
          /**カレントプロジェクトが生きていればnullに更新 */
          if (vxm.theoryApi.authStore.getCurrentProjectId) {
            vxm.theoryApi.authStore.fetchCurrentProjectId(null);
          }
          if (vxm.theoryApi.authStore.getCurrentProjectIds) {
            vxm.theoryApi.authStore.fetchCurrentProjectIds(null);
          }
          /**組織・プロジェクト作成選択ページへ遷移させる */
          next({ name: 'joinSelect' });
          /**所属組織が存在する場合 */
        } else {
          /**カレントプロジェクトIDが無ければプロジェクト作成ページへ遷移させる */
          if (!vxm.theoryApi.authStore.getCurrentProjectId) {
            next({ name: 'createProject' });
          }
          /** マスタデータがストアに無い場合取得する */
          if (!vxm.theoryApi.mastersStore.getExistFlag) {
            await vxm.theoryApi.mastersStore.fetchMasterData();
          }
          /**カレント組織とカレントプロジェクトが存在すれば、任意のページへ遷移させる */
          next();
        }
      }
    }
    /**未ログインユーザーがアクセス可能なページへのアクセス、組織・プロジェクト新規作成関連ページへのアクセスの場合 */
  } else {
    const currentUserInfo = await Auth.currentUserInfo();
    /**セッションが無効であればストアデータの情報をnullに置き換える */
    if (!currentUserInfo) {
      vxm.theoryApi.authStore.deleteCurrentUserInfo();
      /**未ログインユーザーのアクセス可能なページ以外へのアクセスである場合、ログインページへ遷移させる */
      if (
        to.name === 'login' ||
        to.name === 'createAccount' ||
        to.name === 'confirmSignUp' ||
        to.name === 'confirmPassword' ||
        to.name === 'sendConfirmCode'
      ) {
        next();
      } else {
        next({ name: 'login' });
      }
      /**セッションが生きておりstateがnullの場合 */
    } else {
      if (!vxm.theoryApi.authStore.getCurrentUserInfo) {
        /**stateにアカウント情報をset */
        await vxm.theoryApi.authStore.fetchCurrentUserInfo();
        const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo as SignInResponse | null;
        /** 正常に取得出来なかった場合 */
        if (!userInfo) {
          /**未ログインユーザーのアクセス可能なページ以外へのアクセスである場合、ログインページへ遷移させる */
          if (
            to.name === 'login' ||
            to.name === 'createAccount' ||
            to.name === 'confirmSignUp' ||
            to.name === 'confirmPassword' ||
            to.name === 'sendConfirmCode'
          ) {
            next();
          } else {
            next({ name: 'login' });
          }
          /**正常にfetch出来た場合 */
        } else {
          /**所属組織が存在しない場合、カレント組織IDを削除し作成ページへ遷移させる */
          if (!userInfo.results.organizationId) {
            vxm.theoryApi.authStore.fetchCurrentProjectIds(null);
            if (to.name !== 'joinSelect') {
              next({ name: 'joinSelect' });
            } else {
              next();
            }
          } else {
          /**組織IDをsetし、組織のプロジェクトのうちアカウントが現在参画しているものの一覧をstateにset */
            vxm.theoryApi.authStore.fetchCurrentOrganizationId(userInfo.results.organizationId);
            await vxm.theoryApi.accountsStore.fetchAccountBasicParticipationProjects({
              accountId: userInfo.results.accountId,
              organizationId: userInfo.results.organizationId,
            });
            /**プロジェクトIDsをセット */
            if (vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects) {
              const projectIds = vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects.results.map((project) => {
                return project.projectId;
              });
              vxm.theoryApi.authStore.fetchCurrentProjectIds(projectIds);
              /**プロジェクト一覧が無い場合stateを削除 */
            } else {
              vxm.theoryApi.authStore.fetchCurrentProjectIds(null);
            }
            /**プロジェクトIDをセット */
            if (userInfo.results.projectId) {
              vxm.theoryApi.authStore.fetchCurrentProjectId(userInfo.results.projectId);
              /**プロジェクトIDがnullの場合カレントプロジェクトIDを削除 */
            } else {
              vxm.theoryApi.authStore.fetchCurrentProjectId(null);
            }
            /**マスタデータがストアに無い場合取得する */
            if (!vxm.theoryApi.mastersStore.getExistFlag) {
              await vxm.theoryApi.mastersStore.fetchMasterData();
            }
            next();
          }
        }
        /**セッションが生きておりstateが存在する場合 */
      } else {
        /**マスタデータがストアに無い場合取得する */
        if (!vxm.theoryApi.mastersStore.getExistFlag) {
          await vxm.theoryApi.mastersStore.fetchMasterData();
        }
        next();
      }
    }
  }
});

export default router;
